import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { ListItem, ListItemIcon, ListItemText, Icon, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { handleDrawer } from '../../store/actions/menu';

const MenuItem = ({ 
    classes, 
    to, 
    titlePrimary, 
    titleSecondary, 
    leftIcon, 
    iconColor 
}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    // 🆕 Detectar rota ativa
    const isActive = to && location.pathname.startsWith(to);
    
    // 🆕 Fechar drawer em mobile ao clicar
    const handleClick = () => {
        if (isMobile) {
            dispatch(handleDrawer());
        }
    };
    
    return (
        <ListItem 
            button 
            component={Link}
            to={to || '#'}
            className={isActive ? classes.activeItem : classes.inactiveItem}
            selected={isActive}
            aria-label={`Navegar para ${titlePrimary || titleSecondary}`}
            aria-current={isActive ? "page" : undefined}
            onClick={handleClick}
        >
            <ListItemIcon>
                <Tooltip 
                    title={titlePrimary || titleSecondary} 
                    placement="right"
                >
                    <Icon color={iconColor}>
                        {leftIcon}
                    </Icon>
                </Tooltip>
            </ListItemIcon>
            <ListItemText 
                primary={titlePrimary} 
                secondary={titleSecondary}
            />
        </ListItem>
    );
};

export default withStyles(theme => ({
    activeItem: theme.overrides?.activeItem || {},
    inactiveItem: theme.overrides?.inactiveItem || {},
}))(MenuItem);